import React, { useEffect, useState } from 'react'
import {
  TextField,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import dayjs from 'dayjs'
import { makeStyles } from '@material-ui/core/styles'

const InstallmentCalculator = ({
  premium,
  policyStartDate,
  onInstallmentsCalculated,
  prefillData,
  error,
  touched,
  disabled,
}) => {
  const classes = useStyles()
  const [numInstallments, setNumInstallments] = useState(0)
  const [installments, setInstallments] = useState([])

  const calculateInstallments = () => {
    if (!numInstallments || numInstallments <= 0) return

    const installmentsArray = []
    const installmentAmount = (premium / numInstallments)?.toFixed(2)
    let startDate = dayjs(policyStartDate)

    for (let i = 0; i < numInstallments; i++) {
      installmentsArray.push({
        installmentNo: i + 1,
        installmentDate: startDate?.add(i, 'month')?.format('YYYY-MM-DD'),
        installmentAmount: installmentAmount,
      })
    }

    setInstallments(installmentsArray)
    if (onInstallmentsCalculated) {
      onInstallmentsCalculated(installmentsArray)
    }
  }

  const handleInstallmentChange = (index, field, value) => {
    const updatedInstallments = [...installments]
    updatedInstallments[index][field] = value
    setInstallments(updatedInstallments)
    if (onInstallmentsCalculated) {
      onInstallmentsCalculated(updatedInstallments)
    }
  }

  useEffect(() => {
    if (prefillData) {
      setInstallments(prefillData)
      setNumInstallments(prefillData?.length)
    }
    // eslint-disable-next-line
  }, [prefillData])

  return (
    <div className={classes.mainContainer}>
      <p className={classes.calcHeading}>Installment Calculator</p>
      {premium && policyStartDate ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label='Premium'
                variant='outlined'
                fullWidth
                value={premium}
                disabled
                size='small'
                className={classes.field}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label='Number of Installments'
                variant='outlined'
                fullWidth
                type='number'
                value={numInstallments}
                onChange={(e) =>
                  setNumInstallments(parseInt(e?.target?.value, 10) || 1)
                }
                size='small'
                className={classes.field}
                disabled={disabled}
                //   inputProps={{ min: 1 }}
              />
            </Grid>
            {numInstallments > 1 && (
              <Grid item xs={4}>
                <Button
                  variant='contained'
                  color='primary'
                  fullWidth
                  onClick={calculateInstallments}
                  className={classes.calcPremiumBtn}
                >
                  Calculate Installments
                </Button>
              </Grid>
            )}

            {installments.length > 0 && (
              <Grid item xs={12}>
                <div className={classes.installmentHeader}>
                  Installment Schedule:
                </div>
                <TableContainer className={classes.tableContainer}>
                  <Table size='small' stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align='center'>
                          <strong>Sl. No</strong>
                        </TableCell>
                        <TableCell align='center'>
                          <strong>Date</strong>
                        </TableCell>
                        <TableCell align='center'>
                          <strong>Amount (₹)</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {installments?.map((inst, index) => (
                        <TableRow key={inst?.installmentNo}>
                          <TableCell align='center'>
                            {inst?.installmentNo}
                          </TableCell>
                          <TableCell align='center'>
                            <TextField
                              type='date'
                              fullWidth
                              value={inst?.installmentDate}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  'installmentDate',
                                  e?.target?.value
                                )
                              }
                              className={classes.field}
                              size='small'
                              InputLabelProps={{ shrink: true }}
                              disabled={disabled}
                            />
                          </TableCell>
                          <TableCell align='center'>
                            <TextField
                              type='number'
                              fullWidth
                              value={inst?.installmentAmount}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  'installmentAmount',
                                  e?.target?.value
                                )
                              }
                              className={classes.field}
                              size='small'
                              disabled={disabled}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
          {error && touched && (
            <p className={classes.formError}>{error?.installmentDetails}</p>
          )}
        </>
      ) : (
        <div className={classes.errorDisplay}>
          {!premium && <p>Please provide premium</p>}
          {!policyStartDate && <p>Please provide Policy Start Date</p>}
        </div>
      )}
    </div>
  )
}

export default InstallmentCalculator

const useStyles = makeStyles(() => ({
  mainContainer: {
    padding: '20px',
  },
  formError: { color: 'red', fontSize: '14px', marginTop: '5px' },
  calcPremiumBtn: {
    backgroundColor: '#B92250 !important',
    textTransform: 'capitalize !important',
  },
  installmentHeader: {
    fontWeight: 'bold',
    fontSize: '16px',
    padding: '10px 0px',
  },
  tableContainer: {
    border: '1px solid lightgray',
    borderRadius: '5px',
    maxHeight: '310px',
    overflow: 'auto',
  },
  errorDisplay: {
    color: 'red',
    fontWeight: 'bold',
  },
  calcHeading: {
    textAlign: 'center',
    fontSize: '18px',
    color: '#B92250',
    fontWeight: 'bold',
  },
  field: {
    '& .MuiOutlinedInput-input': {
      paddingTop: '10.5px !important',
      paddingBottom: '10.5px !important',
    },
  },
}))
